import React, { useEffect } from 'react';
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useHistory } from "react-router-dom";
import {trackAdditionalPageView} from "../../common/util/ccAnalyticsV2";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration';

const LearnMorePage = ({merchantCode, fetchedImpact}) => {

    const history = useHistory();

    useEffect(() => {
        //trackAdditionalPageView('/learn-more',['aviation','customer'])
    }, []
    );

    return (
        <div>
            <div className="h-85vh w-100 position-relative bg-primary vertical-align-parent text-white" >
                <div className="container vertical-align">
                <h1 className="mb-4 text-shadow mt-0">LEARN MORE</h1>
                </div>
            </div>

            <div id="content" className="py-6">
                <div className="container text-center">
                    
                </div>
            </div>

            <div className="w-100 img-cover footer-img bg-grey py-6" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={"https://carbonclick.com"} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={"https://www.facebook.com/CarbonClickCommunity/"} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={"https://www.instagram.com/carbon.click/"} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={"https://twitter.com/carbonclick"} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://carbonclick.com"} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white" href={"https://www.carbonclick.com/about/"} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://www.carbonclick.com/terms/"} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white" href={"https://www.carbonclick.com/privacy-policy/"} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LearnMorePage;